<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-file"></i> 项目相关</el-breadcrumb-item>
                <el-breadcrumb-item>项目上传</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container" style="min-width: 900px">
            <div class="plugins-tips">
                <el-row :gutter='10'>
                    <el-col :span='15'>
                        <span class='tips-title'>项目名称：</span>
                        <el-autocomplete class='inline-input' size='mini' v-model='query.projectName'
                                         :fetch-suggestions='querySearch' placeholder='请输入内容'
                                         @select='handleSelect'></el-autocomplete>
                        
                        <!--<span class='tips-title' style='margin-left: 50px'>服务器：</span>-->
                        <!--<el-select size='mini' disabled v-model='query.formalOrTest' placeholder='服务器'-->
                        <!--           @change='formalOrTestCurrent($event)' class='handle-select mr10'-->
                        <!--           style=' width: 100px'>-->
                        <!--    <el-option-->
                        <!--        v-for='item in formalOrTestData'-->
                        <!--        :key='item.formalOrTestId'-->
                        <!--        :label='item.name'-->
                        <!--        :value='item.formalOrTestId'>-->
                        <!--    </el-option>-->
                        <!--</el-select>-->
                    </el-col>
                    <el-col :span='9'>
                        <el-alert :closable='false' style='' type='warning'>
                            <p v-html='computeAlertContent' />
                            <p>2. 压缩包内不能存在多个<b>一级文件夹</b>。如果存在多个一级文件夹, 请将他们移至一个文件夹中
                            </p>
                        </el-alert>
                    </el-col>
                </el-row>
            </div>

            <el-form label-position="left" label-width="80px">
                <el-form-item label="版本">
                    <el-input size='mini' placeholder='请输入文件版本号(版本号格式无规定 仅用于区分和管理版本)'
                              v-model='projectMetadata.version'></el-input>
                </el-form-item>
                <el-form-item label="文件描述">
                    <el-input size='mini' placeholder='请输入本次更新描述(仅用于区分和管理版本)' type='textarea'
                              :autosize='{ minRows: 2, maxRows: 4 }' v-model='projectMetadata.description'></el-input>
                </el-form-item>
            </el-form>
            <!-- 上传测试环境 -->
            <el-upload v-if='query.formalOrTest == 1' class='upload-demo' drag action='#' :http-request='upload'
                       :before-upload='beforeUpload' :on-success='handleSuccess' :on-error='handleError'
                       :data='uploadParams'
                multiple>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传 至 测试服</em></div>
                <div class="el-upload__tip" slot="tip">上传前选择好对应项目名称，压缩包类型仅支持.zip格式, 对于热更新, 数据为增量更新</div>

            </el-upload>

            <!-- 上传正式环境 -->
            <div v-if='query.formalOrTest == 0'>
                <!-- 上传方式切换按钮 -->
                <div class='upload-mode-switch' style='margin-bottom: 20px;'>
                    <el-radio-group v-model='uploadMode' @change='onUploadModeChange'>
                        <el-radio-button label='file'>文件上传</el-radio-button>
                        <el-radio-button label='folder'>文件夹上传</el-radio-button>
                    </el-radio-group>
                </div>

                <!-- 文件上传模式 -->
                <el-upload v-if="uploadMode === 'file'" class='upload-demo' drag action='#' :http-request='upload'
                           :before-upload='beforeUpload' :on-success='handleSuccess' :on-error='handleError'
                           :data='uploadParams'>
                    <i class='el-icon-upload'></i>
                    <div class='el-upload__text'>将文件拖到此处，或<em>点击上传文件 至 正式服</em></div>
                    <div class='el-upload__tip' slot='tip'>
                        <el-progress style='width: 368px;' :percentage='progressPercent' v-show='progressPercentShow' />
                    </div>
                    <div class='el-upload__tip' slot='tip'>上传前选择好对应项目名称，压缩包类型仅支持.zip格式, 对于热更新,
                        数据为增量更新
                    </div>
                </el-upload>

                <!-- 文件夹上传模式 -->
                <div v-if="uploadMode === 'folder'" class='directory-upload-area' @click='triggerDirectoryUpload'
                     @drop='handleDirectoryDrop' @dragover.prevent @dragenter.prevent>
                    <i class='el-icon-folder-opened'></i>
                    <div class='el-upload__text'>点击选择文件夹上传 至 正式服</div>
                    <div class='el-upload__tip'>选择整个文件夹进行上传，系统会自动压缩为zip格式</div>
                </div>

                <!-- 隐藏的目录选择input -->
                <input ref='directoryInput' type='file' webkitdirectory directory multiple style='display: none;'
                       @change='handleDirectorySelect'>
            </div>
            
            <el-progress style='margin-top: 1rem;' :percentage='uploadProgress.uploadPercentage'
                         :format='format'></el-progress>
        </div>
    </div>
</template>
<script>
import { queryProjectInfoList } from '@/components/api/ProjectInfo';
import { projectChunkFileApi } from '@api/project/projectChunkFileApi';
import { message } from '@/utils/message';
import { FileUtils } from '@/utils/file';
import JSZip from 'jszip';
import { envConfig } from '@root/env';

export default {
    name: 'Upload',
    data: function() {
        return {
            query: {
                projectId: '',    // 下拉框项目ID
                project: '',      // 下拉框项目对象
                projectName: '',  // 下拉框项目名
                formalOrTest: 0   // 选择服务器  0:正式服  1:测试服
            },
            
            formalOrTestData: [{ formalOrTestId: 1, name: '测试服' }, { formalOrTestId: 0, name: '正式服' }],  //正式或测试服务器
            projects: [],      //下拉框项目名合集
            uploadParams: {},  //上传图片数据
            projectMetadata: {
                version: undefined,
                description: undefined
            },

            progressPercentShow: false,// 上传进度条默认不显示
            progressPercent: 0,        // 上传进度条默认为 0

            uploadedChunkIndexList: [], // 已上传分片下标集合

            chunkSize: 1024 * 1024 * 1.25,
            maxConcurrency: 3,
            uploadProgress: {
                total: 0,
                currentUpdatedCount: 0,
                uploadPercentage: 0
            },
            
            uploadMode: 'file' // 上传模式：'file' 文件上传，'folder' 文件夹上传
        }
    },

    created() {
        this.getProjectName();
    },
    computed: {
        computeAlertContent() {
            let projectName = '{项目名}';
            if (this.query.projectName) {
                projectName = this.query.projectName;
            }
            return `1. 发布后文件路径: <b>${envConfig.cdnUrl}/hotupdate/${projectName}/压缩包内的文件路径</b>`;
        }
    },
    methods: {
        format(percentage) {
            return `${percentage.toFixed(2)}%`;
        },
        //获取项目名称信息
        getProjectName() {
            queryProjectInfoList({ pageSize: 10000 }).then(res => {
                if (res.code === 200) {
                    this.projects = res.data.result
                }
            })
        },

        /**
         * 项目输入框提示数据
         * @param {*} queryString
         * @param {*} cb
         */
        querySearch(queryString, cb) {
            this.projects.forEach(project => {
                project['value'] = project.name
            })

            var restaurants = this.projects;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },

        createFilter(queryString) {
            return (restaurant) => {
                return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },

        /**
         * 选中项目名事件
         * @param {*} item
         */
        handleSelect(item) {
            this.query.projectId = item.appId
            this.query.projectName = item.name
            this.uploadParams = {
                'userName': localStorage.getItem('ms_username'),
                'projectId': this.query.projectId,
                'isTest': this.query.formalOrTest
            };
        },

        //服务器下拉框
        formalOrTestCurrent(event) {
            this.uploadParams = {
                'userName': localStorage.getItem('ms_username'),
                'projectId': this.query.projectId,
                'isTest': this.query.formalOrTest
            };
        },
        
        // 上传模式切换处理
        onUploadModeChange(mode) {
            console.log('上传模式切换为:', mode);
        },

        //上传前
        beforeUpload(file) {
            // 判断是否选择项目
            if (this.query.projectId == undefined || this.query.projectId == '') {
                this.$message.warning('请先选择项目')
                return false
            }
            //格式限制
            var FileExt = file.name.replace(/.+\./, '');
            if (['rar', '7z'].indexOf(FileExt.toLowerCase()) !== -1) {
                this.$message({
                    type: 'warning',
                    message: '不支持 [.rar] [.7z] 类型！'
                });
                return false;
            }
            //大小限制
            let size = file.size / 1024 / 1024
            if (size > 1024) {
                this.$notify.warning({
                    title: '警告',
                    message: '文件大小不得超过1GB'
                });
                return false;
            }
        },
        
        async upload(param) {
            this.uploadProgress.currentUpdatedCount = 0;
            let userName = param.data.userName;
            let projectId = param.data.projectId;
            let isTest = param.data.isTest;
            
            let fileToUpload = param.file;
            let fileChunkArr = this.getFileChunkArr(fileToUpload);
            this.uploadProgress.total = fileChunkArr.length;
            let fileName = fileToUpload.name;
            // 判断所要上传的服务器
            let formalOrTest = ''
            if (this.query.formalOrTest == 0) {
                formalOrTest = '正式服'
            } else if (this.query.formalOrTest == 1) {
                formalOrTest = '测试服'
            } else {
                this.$message.warning('未检测到服务器地址')
                return false
            }
            
            // 二次确认
            this.$confirm('确认上传 ' + param.file.name + ' 至 \u3000 ' + this.query.projectName + ' \u3000 项目下吗？', formalOrTest, {
                type: 'warning'
            }).then(() => {
                FileUtils.getFileMd5(param.file).then(md5 => {
                    projectChunkFileApi.checkAndMerge({
                        userName: param.data.userName,
                        projectId: param.data.projectId,
                        isTest: param.data.isTest,
                        md5: md5
                    }).then(result => {
                        if (result.code === 200) {
                            let uploadResult = result.data;
                            if (uploadResult.finishStatus && uploadResult.finishStatus === true) {
                                message.success('上传成功');
                                this.uploadProgress.uploadPercentage = 100;
                            } else {
                                let chunkUploadStatus = uploadResult.chunkUploadStatus;
                                this.executeChunkUpload(fileChunkArr, chunkUploadStatus, md5, fileName, userName, projectId, isTest);
                            }
                        }
                    })
                })

            }).catch(err => {
                this.$message.success('已取消')
            })
        },
        uploadSingleChunk(data, md5, totalChunkCount, currentChunkNumber, fileName) {
            return () => new Promise((resolve, reject) => {
                let param = {
                    file: new File([data], fileName),
                    chunkSize: this.chunkSize,
                    md5,
                    totalChunkCount,
                    currentChunkNumber
                };
                projectChunkFileApi.chunkUploadFileInfo(param).then(result => {
                    resolve(result);
                });
            });
        },
        getFileChunkArr(file) {
            const chunks = [];
            let start = 0;
            let end;
            while (start < file.size) {
                end = Math.min(start + this.chunkSize, file.size);
                chunks.push(file.slice(start, end));
                start = end;
            }
            return chunks;
        },
        async limitConcurrency(tasks, maxConcurrency, obj) {
            let results = [];
            let running = [];
            
            async function runTask(task) {
                const result = await task();
                obj.uploadProgress.currentUpdatedCount = obj.uploadProgress.currentUpdatedCount + 1;
                obj.computeUploadPercentage();
                results.push(result);
            }
            
            let count = 0;
            for (let task of tasks) {
                if (!task) {
                    continue;
                }
                if (count >= maxConcurrency) {
                    await Promise.all(running);
                    count = 0;
                }
                const p = runTask(task);
                running.push(p);
                count++;
            }
            
            await Promise.all(running);
            return results;
        },
        executeChunkUpload(fileChunkArr, chunkUploadStatus, md5, fileName, userName, projectId, isTest) {
            return new Promise((resolve) => {
                let taskArr = [];
                if (!chunkUploadStatus) {
                    for (let i = 0; i < fileChunkArr.length; i++) {
                        taskArr[i] = this.uploadSingleChunk(fileChunkArr[i], md5, fileChunkArr.length, i, fileName);
                        if (i === fileChunkArr.length - 1) {
                            resolve(taskArr);
                        }
                    }
                } else {
                    message.success('该文件部分已上传 正在进行断点续传');
                    for (let i = 0; i < chunkUploadStatus.length; i++) {
                        let status = chunkUploadStatus.charAt(i);
                        if (status === '0') {
                            // 上传
                            taskArr[i] = this.uploadSingleChunk(fileChunkArr[i], md5, fileChunkArr.length, i, fileName);
                        } else {
                            this.uploadProgress.currentUpdatedCount = this.uploadProgress.currentUpdatedCount + 1;
                            this.computeUploadPercentage();
                        }
                        if (i === chunkUploadStatus.length - 1) {
                            resolve(taskArr);
                        }
                    }
                }
            }).then(taskArr => {
                let startTime = new Date().getTime();
                let version = this.projectMetadata.version
                let description = this.projectMetadata.description
                this.limitConcurrency(taskArr, this.maxConcurrency, this).then(result => {
                    // 所有的都上传完毕后
                    projectChunkFileApi.checkAndMerge({ userName, projectId, isTest, md5: md5, version, description }).then(result => {
                        if (result.code === 200) {
                            let endTime = new Date().getTime();
                            let consumeTime = ((endTime - startTime) / 1000).toFixed(2);
                            console.log(`耗时: ${consumeTime}`);
                            let uploadResult = result.data;
                            if (uploadResult.finishStatus && uploadResult.finishStatus === true) {
                                message.success('上传成功');
                                this.uploadProgress.uploadPercentage = 100;
                            } else {
                                message.error('文件上传失败!');
                            }
                        }
                    });
                });
            })
        },
        // 上传成功回调
        handleSuccess(res) {
            // this.$message.success('res')
        },
        // 上传失败回调
        handleError(res) {
            this.$notify.error({
                title: '警告',
                message: '上传失败'
            });
        },
        computeUploadPercentage() {
            if (this.uploadProgress.currentUpdatedCount === 0) {
                return 0;
            }
            let s = 100 / this.uploadProgress.total;
            this.uploadProgress.uploadPercentage = s * this.uploadProgress.currentUpdatedCount;
        },
        
        
        // 将目录压缩为ZIP文件
        async compressDirectoryToZip(files) {
            console.log(files);
            
            const zip = new JSZip();
            let rootDirName = '';
            const rootDirs = new Set(); // 用于收集所有一级目录
            
            // 处理文件数组
            const fileArray = Array.isArray(files) ? files : [files];
            
            // 第一遍遍历：收集所有一级目录并验证
            for (const file of fileArray) {
                // 获取相对路径，优先使用webkitRelativePath，其次使用自定义的_relativePath
                const relativePath = file.webkitRelativePath || file._relativePath || file.name;
                const pathParts = relativePath.split('/');
                
                if (pathParts.length > 1) {
                    // 这是一个目录中的文件，获取一级目录名
                    rootDirs.add(pathParts[0]);
                } else {
                    // 这是一个直接在根目录的文件，不允许
                    throw new Error('不支持直接选择文件，请选择包含文件的文件夹');
                }
            }
            
            // 验证只能有一个一级目录
            if (rootDirs.size === 0) {
                throw new Error('未检测到有效的文件夹结构');
            } else if (rootDirs.size > 1) {
                const dirList = Array.from(rootDirs).join('、');
                throw new Error(`检测到多个一级目录：${dirList}。请确保选择的文件夹中只包含一个一级目录，如果有多个文件夹，请将它们放在一个父文件夹中再进行上传。`);
            }
            
            // 获取唯一的根目录名称
            console.log('根目录列表', rootDirs);
            
            rootDirName = Array.from(rootDirs)[0];
            
            // 第二遍遍历：添加文件到zip中
            message.success(`正在将${fileArray.length}个文件压缩为ZIP文件...`);
            for (const file of fileArray) {
                // 获取相对路径，优先使用webkitRelativePath，其次使用自定义的_relativePath
                const relativePath = file.webkitRelativePath || file._relativePath || file.name;
                
                // 读取文件内容并添加到zip中
                const fileContent = await this.readFileAsArrayBuffer(file);
                zip.file(relativePath, fileContent);
            }
            
            const zipFileName = rootDirName + '.zip';
            
            // 生成zip文件
            const zipBlob = await zip.generateAsync({ type: 'blob' });
            
            // 创建新的File对象
            return new File([zipBlob], zipFileName, { type: 'application/zip' });
        },
        
        // 读取文件为ArrayBuffer
        readFileAsArrayBuffer(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsArrayBuffer(file);
            });
        },
        
        // 触发目录选择
        triggerDirectoryUpload() {
            // 判断是否选择项目
            if (this.query.projectId == undefined || this.query.projectId == '') {
                this.$message.warning('请先选择项目');
                return false;
            }
            this.$refs.directoryInput.click();
        },
        
        // 处理目录选择
        async handleDirectorySelect(event) {
            const files = Array.from(event.target.files);
            if (files.length === 0) return;
            
            try {
                // this.$message.info('正在验证文件夹结构...');
                const zipFile = await this.compressDirectoryToZip(files);
                
                this.$message.success('文件夹验证通过，开始上传...');
                
                // 直接调用原有的upload方法
                const param = {
                    file: zipFile,
                    data: {
                        userName: localStorage.getItem('ms_username'),
                        projectId: this.query.projectId,
                        isTest: this.query.formalOrTest
                    }
                };
                
                await this.upload(param);
            } catch (error) {
                message.error(error.message);
                // 清空文件选择，允许用户重新选择
                event.target.value = '';
            }
        },
        
        // 处理目录拖拽
        async handleDirectoryDrop(event) {
            event.preventDefault();
            
            // 判断是否选择项目
            if (this.query.projectId == undefined || this.query.projectId == '') {
                this.$message.warning('请先选择项目');
                return false;
            }
            
            const items = event.dataTransfer.items;
            const files = [];
            
            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                if (item.kind === 'file') {
                    const entry = item.webkitGetAsEntry();
                    if (entry) {
                        await this.traverseFileTree(entry, files);
                    }
                }
            }
            
            if (files.length > 0) {
                try {
                    this.$message.info('正在验证文件夹结构...');
                    const zipFile = await this.compressDirectoryToZip(files);
                    
                    this.$message.success('文件夹验证通过，开始上传...');
                    
                    // 直接调用原有的upload方法
                    const param = {
                        file: zipFile,
                        data: {
                            userName: localStorage.getItem('ms_username'),
                            projectId: this.query.projectId,
                            isTest: this.query.formalOrTest
                        }
                    };
                    
                    await this.upload(param);
                } catch (error) {
                    message.error(error.message);
                }
            }
        },
        
        // 遍历文件树
        traverseFileTree(item, files, path = '') {
            return new Promise((resolve) => {
                if (item.isFile) {
                    item.file((file) => {
                        // 创建一个新的文件对象，包含相对路径信息
                        const fileWithPath = new File([file], file.name, {
                            type: file.type,
                            lastModified: file.lastModified
                        });
                        // 使用自定义属性存储相对路径
                        fileWithPath._relativePath = path + file.name;
                        files.push(fileWithPath);
                        resolve();
                    });
                } else if (item.isDirectory) {
                    const dirReader = item.createReader();
                    dirReader.readEntries(async (entries) => {
                        for (const entry of entries) {
                            await this.traverseFileTree(entry, files, path + item.name + '/');
                        }
                        resolve();
                    });
                }
            });
        }


    }
}
</script>

<style scoped>
.tips-group {
    display: inline-block;
    margin-left: 3%;
}

.tips-title {
    color: #57595c
}

.content-title {
    font-weight: 400;
    line-height: 50px;
    margin: 10px 0;
    font-size: 22px;
    color: #1f2f3d;
}

.pre-img {
    width: 100px;
    height: 100px;
    background: #f8f8f8;
    border: 1px solid #eee;
    border-radius: 5px;
}

.crop-demo {
    display: flex;
    align-items: flex-end;
}

.crop-demo-btn {
    position: relative;
    width: 100px;
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    margin-left: 30px;
    background-color: #409eff;
    color: #fff;
    font-size: 14px;
    border-radius: 5px;
    box-sizing: border-box;
}

.crop-input {
    position: absolute;
    width: 100px;
    height: 40px;
    left: 0;
    top: 0;
    opacity: 0;
    cursor: pointer;
}

.up-content {
    border: 1px solid #C2C2C2;
    margin-top: 29px;
    padding: 10px;
    display: none;
    border-radius: 5px;
    box-shadow: 3px 3px 10px #C2C2C2;
}

.directory-upload-area {
    border: 2px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    text-align: center;
    padding: 40px 20px;
    margin-top: 20px;
    background-color: #fafafa;
    transition: border-color 0.3s;
}

.directory-upload-area:hover {
    border-color: #409eff;
    background-color: #f5f7fa;
}

.directory-upload-area i {
    font-size: 67px;
    color: #c0c4cc;
    margin-bottom: 16px;
    line-height: 50px;
}

.directory-upload-area:hover i {
    color: #409eff;
}

.directory-upload-area .el-upload__text {
    color: #606266;
    font-size: 14px;
    text-align: center;
}

.directory-upload-area .el-upload__tip {
    font-size: 12px;
    color: #606266;
    margin-top: 7px;
    text-align: center;
}

.upload-mode-switch {
    text-align: left;
}

.upload-mode-switch .el-radio-group {
    background-color: #f5f7fa;
    border-radius: 4px;
    padding: 4px;
}

.upload-mode-switch .el-radio-button__inner {
    border: none;
    background-color: transparent;
    color: #606266;
    font-weight: 500;
}

.upload-mode-switch .el-radio-button.is-active .el-radio-button__inner {
    background-color: #409eff;
    color: #fff;
    box-shadow: none;
}
</style>
